<template>
  <div id="projectApproval">
		<el-card :class="detailShow? 'hiddencard' : ''">
			<el-form :model="searchForm" ref="searchForm" label-width="160px">
				<el-row>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="E-flow Name:" prop="flowName">
							<el-input clearable v-model="searchForm.flowName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="E-flow Type:" prop="flowType">
							<el-select clearable v-model="searchForm.flowType" placeholder="Please select">
								<el-option
									v-for="item in flowType"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Approval Status:" prop="approvalStatus">
							<el-select clearable v-model="searchForm.approvalStatus" placeholder="Please select">
								<el-option
									v-for="item in applyStatus"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Current Processor:" prop="currentProcessor">
							<el-select
								v-model="searchForm.currentProcessor"
								clearable
								filterable
								remote
								placeholder="Please input"
								:remote-method="value => remoteMethod('currentProcessorList', value)"
							>
								<el-option v-for="(item, index) in currentProcessorList" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="24" :lg="16" :md="24" style="padding: 10px 0 0 20px; text-align: right;">
						<el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
						<el-button size="small" @click="handleReset()">Reset</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
        <el-table-column prop="flowName" label="E-flow Name" align="center" min-width="150">
					<template slot-scope="scope">
          	<a size="small" type="primary" @click="openDetail(scope.row, false)">{{ scope.row.flowName }}</a>
					</template>
				</el-table-column>
        <el-table-column prop="flowTypeDesc" label="E-flow Type" align="center"></el-table-column>
        <el-table-column prop="approvalStatusDesc" label="Approval Status" align="center">
					<template slot-scope="scope">
						<el-button type="text" v-if="scope.row.approvalStatus === 4 || scope.row.approvalStatus === 3" @click="getApprovalHistory(scope.row)">{{ scope.row.approvalStatusDesc }}</el-button>
						<span v-else>{{ scope.row.approvalStatusDesc }}</span>
          </template>
				</el-table-column>
        <el-table-column prop="currentProcessor" label="Current Processor" align="center"></el-table-column>
        <el-table-column prop="submissionTime" label="Submission Time" align="center"></el-table-column>
        <el-table-column prop="lastProcessor" label="Last Processor" align="center"></el-table-column>
        <el-table-column prop="lastProcessedTime" label="Last Processed Time" align="center"></el-table-column>
        <el-table-column prop="nextProcessor" label="Next Processor" align="center"></el-table-column>
        <el-table-column prop="operation" label="Operation" align="center">
					<template slot-scope="scope">
          	<el-button size="small" type="primary" @click="openWithdraw(scope.row)" v-if="scope.row.flowType === 1 && scope.row.approvalStatus === 2">Withdraw</el-button>
          	<el-button size="small" type="primary" @click="openDetail(scope.row, true)" v-if="scope.row.flowType === 1 && (scope.row.approvalStatus === 1 || scope.row.approvalStatus === 4)">Edit</el-button>
					</template>
				</el-table-column>
      </el-table>
			<div class="pageDiv" v-if="totalCount && totalCount > 0">
				<el-pagination
					small
					layout="total, prev, pager, next, sizes, jumper"
					:page-sizes="[10, 20, 50, 100]"
					:current-page="currentPage"
					:page-size="pageSize"
					:total="totalCount"
					@size-change="changePageSize"
					@current-change="changePage"

				>
				</el-pagination>
			</div>
		</el-card>
		<detail v-if="detailShow" :id="detailId" page="myFlow" :flowCanEdit="canEdit" @closeDetail="closeDetail" />
  </div>
</template>
<script>
	import detail from '../../major/projectApplication/index.vue'
  export default {
    name: 'workbenchToDoMyFlow',
		components: {
			detail
		},
    created () {
			this.getSelectInfo();
			this.handleSearch();
    },
    data () {
      return {
				flowType: [],
				applyStatus: [],
				searchForm: {},
				tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 1,
				discardVisible: false,
				currentProcessorList: [],
				detailShow: false,
				detailId: '',
				canEdit: false,
      }
    },
    methods: {
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'applyStatus',
					'flowType',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key]; 
							});
						}
					}
				)
			},
			getApprovalHistory(record) {
				this.approveDrawer = true
				this.approveInfo = record
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					eosToken : sessionStorage.getItem('eostoken'),
				}
				let url =`${this.$store.state.islhurl}majorProjectFlowRecord/getFlowRecordByFlowId?flowId=${record.id}`
				const _this = this
				this._post(url,params).then(
					res => {
						if(res.code === 200 && res.data) {
							let msg = ''
							res.data.forEach(item=> {
								msg += `<p>${item}</p>`
							})
							const msgall = `<div>${msg}</div>`
							_this.$alert(msgall, 'Approval History', {
								customClass:'history-msg-box',
								dangerouslyUseHTMLString: true,
								confirmButtonText: 'OK',
							});
						}
					}
				)
			},
			handleSearch() {
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
          eosToken : sessionStorage.getItem('eostoken'),
					...this.searchForm,
				}
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}majorProjectFlow/getMyFlowListByPage/${this.pageSize}/${this.currentPage}`
				this._post(url,params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
						this.tableData = res.data;
						this.totalCount = res.totalNums;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			handleReset() {
				this.searchForm = {};
			},
			handleExport() {
				this.exportLoading = true;
				this.exportLoading = false;
			},
			openDetail(record, canEdit) {
				console.log('record', record)
				this.detailShow = true;
				this.detailId = record.majorProjectId;
				this.canEdit = canEdit
				// let params = {
				// 	id: record.majorProjectId,
				// 	page: 'myFlow'
				// }
				// this.$router.push({ name:'projectApplication', params });
			},
			closeDetail(type) {
				this.detailShow = false;
				this.detailId = '';
				if(type === 'refresh') {
					this.handleSearch();
				}
			},
			openWithdraw(record) {
				this.$confirm("Are you sure to withdraw?", "Warning", {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					let params = {
						id: record.id,
						approvalStatus: record.approvalStatus,
						procInsId:  record.procInsId,
						islhToken : sessionStorage.getItem('islhtoken'),
						eosToken : sessionStorage.getItem('eostoken'),
					}
					let url = `${this.$store.state.islhurl}majorProjectFlow/revoke`
					this._post(url,params).then(
						res => {
							if (res.code === 200) {
								this.$Message.success('Withdraw Successful!' )
								this.handleSearch();
							} else {
								this.$message.error(res.message || 'Failed!');
							}
						}
					)
				}).catch(() => {
				});
			},
		},
  }
</script>
<style lang="less" scoped>
#projectApproval {
	.el-message {
		z-index: 99999;
	}
	.hiddencard {
		height: 0;
		overflow: hidden;
	}
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	/deep/.el-table .cell {
		word-break: break-word;
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	/deep/.el-dialog__body {
		border-top: 1px solid #e8eaec;
		border-bottom: 1px solid #e8eaec;
		.el-form {
			padding: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/myworkbench/myFlow/index.vue